import { render, staticRenderFns } from "./beneficiary-aud-bt-postcode.vue?vue&type=template&id=7af6508e&"
import script from "./beneficiary-aud-bt-postcode.vue?vue&type=script&lang=js&"
export * from "./beneficiary-aud-bt-postcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports